import React from "react";
import { loadTractorCatalog, STANDALONE_UNITS_CHANGED_EVENT } from "../lib/tractorAssignmentsApi.js";
import { subscribePlanningStateChange } from "../utils/planningCrossViewSync.js";

// Catalogue des camions de la journée affichée, pour « Ajouter » et les lignes vides du Gantt.
// Relu à l'ouverture, au changement de date ou de période, après chaque geste sur une ligne vide,
// après un changement de chauffeur ou d'attelage, et après un changement du planning (Optimiser, Mise à jour…).
export default function useStandaloneUnitsCatalog({ dispatchDate = "", dispatchPeriod = "day", enabled = true } = {}) {
  const [state, setState] = React.useState({ catalog: null, error: "" });
  const [refreshKey, setRefreshKey] = React.useState(0);
  const reload = React.useCallback(() => setRefreshKey((value) => value + 1), []);
  React.useEffect(() => {
    window.addEventListener(STANDALONE_UNITS_CHANGED_EVENT, reload);
    window.addEventListener("grain-driver-assignments-changed", reload);
    const unsubscribe = subscribePlanningStateChange((detail) => {
      if (!detail?.dispatchDate || detail.dispatchDate === dispatchDate) reload();
    });
    return () => {
      window.removeEventListener(STANDALONE_UNITS_CHANGED_EVENT, reload);
      window.removeEventListener("grain-driver-assignments-changed", reload);
      unsubscribe();
    };
  }, [dispatchDate, reload]);
  React.useEffect(() => {
    if (!enabled || !dispatchDate) {
      setState({ catalog: null, error: "" });
      return undefined;
    }
    const controller = new AbortController();
    loadTractorCatalog({ dispatchDate, dispatchPeriod, signal: controller.signal })
      .then((catalog) => setState({ catalog, error: "" }))
      .catch((failure) => { if (failure.name !== "AbortError") setState({ catalog: null, error: failure.message }); });
    return () => controller.abort();
  }, [dispatchDate, dispatchPeriod, enabled, refreshKey]);
  return { ...state, reload };
}
